<template>
  <div>
    <b-dropdown dropdown-right block right text="Sort" variant="outline-primary">
      <b-dropdown-item class="dd-item" :active="$_vModel == null" @click.native="onSelect(null)"
        >Recommended</b-dropdown-item
      >
      <b-dropdown-header>
        <div class="dd-header">Publish</div>
      </b-dropdown-header>
      <b-dropdown-item
        v-for="o in publishOption"
        :id="o.value"
        :key="o.value"
        class="dd-item"
        :active="o.value == $_vModel"
        @click.native="onSelect(o.value)"
        >{{ o['label'] }}</b-dropdown-item
      >
      <b-dropdown-header variant="dark" style="font-weight: bold">
        <template>
          <div class="dd-header">Price</div>
        </template>
      </b-dropdown-header>
      <b-dropdown-item
        v-for="o in priceOption"
        :id="o.value"
        :key="o.value"
        class="dd-item"
        :active="o.value == $_vModel"
        @click.native="onSelect(o.value)"
        >{{ o['label'] }}</b-dropdown-item
      >
    </b-dropdown>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'vModel',
    event: 'change'
  },
  props: {
    vModel: {
      type: String,
      default: 'publish-new-old'
    }
  },
  data() {
    return {
      options: [
        {
          group: 'Publish',
          value: 'publish-new-old',
          label: 'Latest - Oldest'
        },
        {
          group: 'Publish',
          value: 'publish-old-new',
          label: 'Oldest - Latest'
        },
        {
          group: 'Price',
          value: 'price-high-low',
          label: 'High - Low'
        },
        {
          group: 'Price',
          value: 'price-low-high',
          label: 'Low - High'
        }
      ]
    };
  },
  computed: {
    publishOption() {
      return this.options.filter((option) => {
        if (option.group === 'Publish') return option;
      });
    },
    priceOption() {
      return this.options.filter((option) => {
        if (option.group === 'Price') return option;
      });
    },
    isSelected(value) {
      return value == this.$_vModel;
    },
    $_vModel: {
      get() {
        return this.vModel;
      },

      set(v) {
        this.$emit('change', v);
      }
    }
  },

  methods: {
    onSelect(selectedOption) {
      this.$emit('change', selectedOption);
    }
  }
};
</script>

<style lang="scss" scoped>
.dd-header {
  font-weight: bold;
  color: black;
  font-size: medium;
  padding: 0;
}
</style>
